export enum PlatformType {
    Admin,
    Dealer,
}


// export const ContractStatusMapping = {
//     0: '未审核',
//     1: '生效',
//     2: '审核中',
//     3: '已拒绝',
//     forDict(valueField = 'value', textField = 'text') {
//         return Object.keys(this).filter(k => k != 'forDict').map((key) => {
//             const keyTrans = key as ContractStatusKey;
//             return {[valueField]: keyTrans, [textField]: this[keyTrans]}
//         }) as any;
//     }
// }

export enum ContractStatusEnum {
    UnApproved = 0,
    Approved = 1,
    Approving = 2,
    Rejected = 3
}

export const ContractStatusMapping: { [key: number]: string } = {
    [ContractStatusEnum.UnApproved]: '未审核',
    [ContractStatusEnum.Approved]: '生效',
    [ContractStatusEnum.Approving]: '审核中',
    [ContractStatusEnum.Rejected]: '已拒绝'
}

export const ContractStatusOptions = Object.keys(ContractStatusMapping).map(k => ({
    value: k,
    text: ContractStatusMapping[parseInt(k)]
}))


export enum PaymentStatusEnum {
    UnPaid = 0,
    PartPaid = 10,
    Paid = 20
}

export const PaymentStatusMapping: { [key: number]: string } = {
    0: '未付款',
    20: '已付款',
    10: '部分付款'
}

export enum PresaleOrderStatusEnum {
    CLOSED = -1,
    NOT_SUBMITTED = 0,
    SUBMITTED = 10,
    PART_COMPLETED = 20,
    COMPLETED = 30,
}

export enum SalesOrderStatusEnum {
    CLOSED = -1,
    NOT_SUBMITTED = 0,
    OVERDUE_PENDING = 10,
    BUSINESS_PENDING = 20,
    OA_PENDING = 30,
    PAYMENT_PENDING = 40,
    DELIVERY_PENDING = 50,
    PART_DELIVERY = 60,
    DELIVERED = 70,
    RECEIVED = 80
}

export enum ConsignmentOrderStatusEnum {
    CLOSED = -1,
    NOT_SUBMITTED = 0,
    SUBMITTED = 10,
    OA_PENDING = 20,
    DELIVERY_PENDING = 30,
    DELIVERED = 40,
    COMPLETED = 50,
}

export const PresaleOrderStatusMapping: { [key: number]: string } = {
    [-1]: '已关闭',
    0: '未提交',
    10: '已提交',
    20: '部分完成',
    30: '已完成',
}

export const SalesOrderStatusMapping: { [key: number]: string } = {
    [-1]: '订单关闭',
    0: '未提交',
    10: '超期待确认',
    20: '商务待确认',
    30: 'OA审核中',
    40: '待付款',
    50: '待出库',
    60: '部分发货',
    70: '已出库',
    80: '确认收货'
}

export const ConsignmentOrderStatusMapping: { [key: number]: string } = {
    [-1]: '订单关闭',
    0: '未提交',
    10: '已提交',
    20: 'OA审核中',
    30: '待出库',
    40: '已出库',
    50: '已完成',
}

export const PresaleOrderStatusOptions = Object.keys(PresaleOrderStatusMapping).map(k => ({
    value: parseInt(k),
    text: PresaleOrderStatusMapping[parseInt(k)]
}));

export const SalesOrderStatusOptions = Object.keys(SalesOrderStatusMapping).filter(k => k != SalesOrderStatusEnum.OA_PENDING.toString()).map(k => ({
    value: parseInt(k),
    text: SalesOrderStatusMapping[parseInt(k)]
}));

export const ConsignmentOrderStatusOptions = Object.keys(ConsignmentOrderStatusMapping).map(k => ({
    value: parseInt(k),
    text: ConsignmentOrderStatusMapping[parseInt(k)]
}))
export const PaymentStatusOptions = Object.keys(PaymentStatusMapping).map(k => ({
    value: parseInt(k),
    text: PaymentStatusMapping[parseInt(k)]
}));

export const DealerStatusMapping: { [key: number]: string } = {
    0: '未审核',
    1: '审核中',
    2: '已审核',
    3: '终止',
}
export const DealerVersionStatusMapping: { [key: number]: string } = {
    0: '未审核',
    1: '审核中',
    2: '已审核',
    3: '已拒绝',
}


export enum RebateBusinessScopeEnum {
    All = 0,
    Category = 1,
    Product = 2,
    Contract = 3,
};
export const RebateBusinessScopeMapping: { [key: number]: string } = {
    [RebateBusinessScopeEnum.All]: '全部',
    [RebateBusinessScopeEnum.Category]: '产品线',
    [RebateBusinessScopeEnum.Product]: '商品',
    [RebateBusinessScopeEnum.Contract]: '合同',
};

export const RebateBusinessScopeOption = Object.keys(RebateBusinessScopeMapping).map(k => ({
    value: parseInt(k),
    text: RebateBusinessScopeMapping[parseInt(k)],
}));

export enum RebateStatusEnum {
    Unapproved = 0,
    Approved = 1,
    Enable = 2,
    Closed = 3
}

export const RebateStatusMapping: { [key: number]: string } = {
    [RebateStatusEnum.Unapproved]: '未审核',
    [RebateStatusEnum.Approved]: '已审核',
    [RebateStatusEnum.Enable]: '已生效',
    [RebateStatusEnum.Closed]: '已关闭',
}

export enum SalesOrderSourceEnum {
    preOrder = 'preOrder',
    outStockOrder = 'outStockOrder',
    consignmentOrder = 'consignmentOrder'
}

export const SalesOrderSourceMap: { [key: string]: string } = {
    [SalesOrderSourceEnum.preOrder]: '预订订单',
    [SalesOrderSourceEnum.outStockOrder]: '缺货订单',
    [SalesOrderSourceEnum.consignmentOrder]: '寄售申请',
}
export const SalesOrderSourceOptions = Object.keys(SalesOrderSourceMap).map(k => ({
    value: k,
    text: SalesOrderSourceMap[k]
}));

export const RebateStatusOptions = Object.keys(RebateStatusMapping).map(k => ({
    value: parseInt(k),
    text: RebateStatusMapping[parseInt(k)],
}));

export enum OuterOrderStatusEnum {
    Closed = -1,
    UnPlacingOrder = 0,
    PlacedOrder = 1,
}

export const OuterOrderStatusMapping: { [key: string]: string } = {
    [OuterOrderStatusEnum.Closed]: '已关闭',
    [OuterOrderStatusEnum.UnPlacingOrder]: '未下单',
    [OuterOrderStatusEnum.PlacedOrder]: '已下单',
}

//-1，已关闭；0，未下单；1，部分下单；2，已下单；
export enum OuterOrderHeaderStatusEnum {
    Closed = -1,
    UnPlacingOrder = 0,
    PartlyPlacedOrder = 1,
    PlacedOrder = 2,
    Unconfirmed = 3,
}

export const OuterOrderHeaderStatusMapping: { [key: string]: string } = {
    [OuterOrderHeaderStatusEnum.Closed]: '已关闭',
    [OuterOrderHeaderStatusEnum.UnPlacingOrder]: '未下单',
    [OuterOrderHeaderStatusEnum.PartlyPlacedOrder]: '部分下单',
    [OuterOrderHeaderStatusEnum.PlacedOrder]: '已下单',
    [OuterOrderHeaderStatusEnum.Unconfirmed]: '未确认',
}
export const OuterOrderHeaderStatusOptions = Object.keys(OuterOrderHeaderStatusMapping).map(k => ({
    value: parseInt(k),
    text: OuterOrderHeaderStatusMapping[parseInt(k)]
}))

export enum SampleDealerQuotaTransactionTypeEnum {
    Add = 10,
    Use = 20,
}

export const SampleDealerQuotaTransactionTypeMapping: { [key: string]: string } = {
    [SampleDealerQuotaTransactionTypeEnum.Add]: '新增',
    [SampleDealerQuotaTransactionTypeEnum.Use]: '使用'
}

export const RolePermissionOptions = [
    {id: 0, name: '全部'},
    {id: 1, name: '部门'},
    {id: 2, name: '个人'},
]

export const RolePermissionMapping: { [key: string]: string } = {
    0: '全部',
    1: '部门',
    2: '个人',
}

export const LogType = {
    SalesOrder: "sales-order",
    PresaleOrder: "pre-sales-order",
    ConsignmentOrder: "consignment-order",
}
